var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgN5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #005799;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m29.44,27.27c3.01,0,5.37.75,7.1,2.24s2.59,3.53,2.59,6.12c0,2.96-.94,5.27-2.82,6.95-1.88,1.68-4.48,2.52-7.78,2.52s-5.67-.51-7.36-1.54v-3.12c.91.59,2.04,1.04,3.4,1.38s2.69.5,4,.5c2.29,0,4.07-.54,5.34-1.62s1.9-2.64,1.9-4.69c0-3.98-2.44-5.98-7.32-5.98-1.24,0-2.89.19-4.96.57l-1.68-1.07,1.07-13.36h14.2v2.99h-11.43l-.72,8.57c1.5-.3,2.99-.45,4.47-.45Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgN5);
export default __webpack_public_path__ + "static/media/n5.c384e2244cbfbfd367b14d3ec497136d.svg";
export { ForwardRef as ReactComponent };